import { apiFetch } from '@/lib/api';
import { Button } from '@/components/ui/Button';

export type SiteInheritMeta = {
  parent_site_id?: number | null;
  parent_site_name?: string;
  content_inherit_parent?: boolean;
  interface_inherit_parent?: boolean;
};

type Props = {
  scope: 'content' | 'interface';
  siteId: number;
  inherit: SiteInheritMeta | null | undefined;
  onRestored?: () => void;
};

export function SiteParentInheritBanner({ scope, siteId, inherit, onRestored }: Props) {
  if (!inherit?.parent_site_id) {
    return null;
  }
  const parentLabel = inherit.parent_site_name?.trim() || `站点 #${inherit.parent_site_id}`;
  const isInheriting =
    scope === 'content' ? !!inherit.content_inherit_parent : !!inherit.interface_inherit_parent;

  async function restoreInherit() {
    if (siteId < 1) return;
    const r = await apiFetch<{ ok: boolean; err?: string }>('restore_site_settings_parent_inherit', {
      method: 'POST',
      body: JSON.stringify({ site_id: siteId, scope }),
    });
    if (r.ok) {
      onRestored?.();
    }
  }

  if (isInheriting) {
    return (
      <div className="rounded-xl border border-sky-200/90 bg-gradient-to-r from-sky-50 to-white px-4 py-3 text-sm text-sky-950 shadow-sm">
        <p className="font-medium">
          当前为二级站点，{scope === 'content' ? '内容与样式' : '接入与推送'}默认继承一级站点「{parentLabel}」
        </p>
        <p className="mt-1 text-xs leading-relaxed text-sky-900/85">
          下方展示的是<strong className="font-semibold">生效配置</strong>（含 Webhook 密钥，与入库、推草稿、金数据映射一致）。修改并保存后，将仅对本二级站点生效。与一级共用密钥时，金数据推送地址请使用本页带{' '}
          <code className="rounded bg-sky-100/80 px-1 text-[11px]">site_id</code> 的完整 URL。
        </p>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-amber-200/90 bg-amber-50/90 px-4 py-3 text-sm text-amber-950 shadow-sm">
      <p className="font-medium">本二级站点已单独配置{scope === 'content' ? '内容与样式' : '接入与推送'}</p>
      <p className="mt-1 text-xs leading-relaxed text-amber-900/90">
        当前不再自动同步一级站点「{parentLabel}」的对应设置（含 Webhook 密钥）。若希望恢复为与一级站点一致，可点击下方按钮。
      </p>
      <div className="mt-3">
        <Button type="button" variant="secondary" size="sm" onClick={() => void restoreInherit()}>
          恢复继承一级站点
        </Button>
      </div>
    </div>
  );
}
